import React, { FC } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import { FilterRows } from 'src/common/components/skeletons/FilterRows';
import { TableSkeleton } from 'src/common/components/skeletons/table-skeleton/TableSkeleton';

import './WebSdkTestIssuesSkeleton.scss';

interface WebSdkTestIssuesSkeletonProps {
	isAnimated?: boolean;
}

export const WebSdkTestIssuesSkeleton: FC<WebSdkTestIssuesSkeletonProps> = ({
	isAnimated = true
}) => {
	const animationSpeed = isAnimated ? undefined : 0;
	const filterHeight = '60px';

	return (
		<div className="web-sdk-test-issues-skeleton">
			{/* Main title skeleton */}
			<div className="skeleton-main-title">
				<EvSkeleton height="28px" width="180px" animationSpeed={animationSpeed} />
			</div>

			{/* Info section skeleton (ReportInfo) */}
			<div className="skeleton-info-section">
				<div className="skeleton-info-items">
					<div className="skeleton-data-item">
						<EvSkeleton height="46px" width="142px" animationSpeed={animationSpeed} />
					</div>
					<div className="skeleton-data-item">
						<EvSkeleton height="46px" width="90px" animationSpeed={animationSpeed} />
					</div>
					<div className="skeleton-data-item">
						<EvSkeleton height="46px" width="60px" animationSpeed={animationSpeed} />
					</div>
				</div>
			</div>

			{/* Horizontal divider */}
			<div className="skeleton-divider" />

			{/* Filters section skeleton */}
			<div className="skeleton-filters-section">
				<FilterRows
					count={1}
					height={filterHeight}
					width="268px"
					animationSpeed={animationSpeed}
					keySet={['search']}
				/>
				<FilterRows
					count={1}
					height={filterHeight}
					width="240px"
					animationSpeed={animationSpeed}
					keySet={['url']}
				/>
				<FilterRows
					count={3}
					height={filterHeight}
					width="140px"
					animationSpeed={animationSpeed}
					keySet={Array.from({ length: 3 }, (_, i) => `filter_${i}`)}
				/>
				<FilterRows
					count={2}
					height="40px"
					width="70px"
					animationSpeed={animationSpeed}
					keySet={Array.from({ length: 2 }, (_, i) => `action_${i}`)}
				/>
			</div>

			{/* Table section skeleton */}
			<div className="skeleton-table-section">
				<div className="skeleton-section-title">
					<EvSkeleton height="23px" width="150px" animationSpeed={animationSpeed} />
				</div>
				<TableSkeleton columns={6} rowCount={10} />
			</div>
		</div>
	);
};
